export const removeFalsyKeys = <T extends Record<string, unknown>>(
  object: T
): Partial<T> => {
  const result = { ...object };

  for (const key in result) {
    if (result[key] === null || result[key] === undefined) {
      delete result[key];
    }
  }

  return result;
};
